import { GenericLazyString } from '@eventbrite/i18n';

export type Sublocalities = {
    [key: string]: GenericLazyString;
};

export type ParentLocation = {
    parentSlug: string;
    sublocalities: Sublocalities;
};

const LOS_ANGELES_SUBLOCALITY_FILTER: ParentLocation = {
    parentSlug: 'ca--los-angeles',
    sublocalities: {
        'neighbourhood/85865811': new GenericLazyString(() => 'Downtown'),
        'neighbourhood/85826037': new GenericLazyString(() => 'Hollywood'),
        'neighbourhood/1092456411': new GenericLazyString(
            () => 'Beverly Grove',
        ),
        'neighbourhood/85865827': new GenericLazyString(() => 'East Hollywood'),
        'neighbourhood/85856747': new GenericLazyString(() => 'Westchester'),
        'neighbourhood/85865837': new GenericLazyString(() => 'Historic Core'),
        'neighbourhood/85865847': new GenericLazyString(() => 'Silver Lake'),
        'neighbourhood/85832373': new GenericLazyString(() => 'Mar Vista'),
        'neighbourhood/85851717': new GenericLazyString(() => 'Sylmar'),
        'neighbourhood/85857293': new GenericLazyString(() => 'Westwood'),
        'neighbourhood/85837735': new GenericLazyString(
            () => 'North Hollywood',
        ),
        'neighbourhood/85866825': new GenericLazyString(() => 'Chinatown'),
        'neighbourhood/85853579': new GenericLazyString(() => 'Venice'),
        'neighbourhood/85865829': new GenericLazyString(
            () => 'Hollywood Studio District',
        ),
        'neighbourhood/85865821': new GenericLazyString(() => 'Westlake'),
    },
};

const CHICAGO_SUBLOCALITY_FILTER: ParentLocation = {
    parentSlug: 'il--chicago',
    sublocalities: {
        'borough/957999223': new GenericLazyString(() => 'Central'),
        'borough/958020405': new GenericLazyString(() => 'North Side'),
        'borough/957979099': new GenericLazyString(() => 'West Side'),
        'neighbourhood/85831409': new GenericLazyString(() => 'The Loop'),
        'borough/958036681': new GenericLazyString(() => 'South Side'),
        'neighbourhood/85865755': new GenericLazyString(() => 'Maplewood'),
        'neighbourhood/85866935': new GenericLazyString(() => 'West Town'),
        'neighbourhood/85865743': new GenericLazyString(
            () => 'Kinzies Addition',
        ),
        'neighbourhood/85829473': new GenericLazyString(() => 'Lakeview'),
        'neighbourhood/85836443': new GenericLazyString(
            () => 'Near North Side',
        ),
        'neighbourhood/85865737': new GenericLazyString(() => 'South Loop'),
        'neighbourhood/85866931': new GenericLazyString(() => 'River North'),
        'neighbourhood/420783539': new GenericLazyString(
            () => 'Wrightwood Neighbors',
        ),
        'neighbourhood/1024497033': new GenericLazyString(() => 'Grant Park'),
        'neighbourhood/85826681': new GenericLazyString(() => 'Hyde Park'),
        'neighbourhood/85869277': new GenericLazyString(() => 'Goose Island'),
        'neighbourhood/420518923': new GenericLazyString(() => 'Wicker Park'),
        'neighbourhood/1024496909': new GenericLazyString(
            () => 'Dearborn Park',
        ),
        'neighbourhood/1024496983': new GenericLazyString(
            () => 'Sheffield Neighbors',
        ),
        'neighbourhood/85867527': new GenericLazyString(() => 'Bronzeville'),
        'neighbourhood/85865759': new GenericLazyString(() => 'Ravenswood'),
    },
};

const NEW_YORK_SUBLOCALITY_FILTER: ParentLocation = {
    parentSlug: 'ny--new-york',
    sublocalities: {
        'borough/421205771': new GenericLazyString(() => 'Manhattan'),
        'borough/421205765': new GenericLazyString(() => 'Brooklyn'),
        'neighbourhood/85831563': new GenericLazyString(
            () => 'Lower East Side',
        ),
        'borough/421205767': new GenericLazyString(() => 'Queens'),
        'neighbourhood/85882233': new GenericLazyString(() => 'Midtown West'),
        'neighbourhood/85865713': new GenericLazyString(() => 'Tribeca'),
        'neighbourhood/85857853': new GenericLazyString(() => 'Williamsburg'),
        'neighbourhood/85831303': new GenericLazyString(
            () => 'Long Island City',
        ),
        'neighbourhood/85810589': new GenericLazyString(() => 'Chelsea'),
        'neighbourhood/85868041': new GenericLazyString(() => 'Kips Bay'),
        'neighbourhood/85865569': new GenericLazyString(() => 'City Hall Area'),
        'neighbourhood/907215785': new GenericLazyString(() => 'Midtown East'),
        'neighbourhood/85816887': new GenericLazyString(() => 'East Village'),
        'neighbourhood/420529189': new GenericLazyString(
            () => 'Greenwich Village',
        ),
        'borough/421205773': new GenericLazyString(() => 'The Bronx'),
        'neighbourhood/85865711': new GenericLazyString(
            () => 'Financial District',
        ),
        'neighbourhood/85808635': new GenericLazyString(() => 'Bushwick'),
        'neighbourhood/85803821': new GenericLazyString(() => 'Astoria'),
        'neighbourhood/85853285': new GenericLazyString(() => 'West Side'),
        'neighbourhood/85865691': new GenericLazyString(
            () => 'Upper East Side',
        ),
        'neighbourhood/85856577': new GenericLazyString(() => 'West Village'),
        'neighbourhood/85869191': new GenericLazyString(
            () => 'Downtown Brooklyn',
        ),
        'neighbourhood/85892907': new GenericLazyString(
            () => 'Bedford-Stuyvesant',
        ),
        'neighbourhood/85869245': new GenericLazyString(
            () => 'Flatiron District',
        ),
        'neighbourhood/85865687': new GenericLazyString(() => 'SoHo'),
        'neighbourhood/85868039': new GenericLazyString(() => "Hell's Kitchen"),
        'neighbourhood/85865555': new GenericLazyString(() => 'Central Harlem'),
    },
};

const SAN_FRANCISCO_SUBLOCALITY_FILTER: ParentLocation = {
    parentSlug: 'ca--san-francisco',
    sublocalities: {
        'neighbourhood/85865939': new GenericLazyString(() => 'Soma'),
        'neighbourhood/85834637': new GenericLazyString(() => 'Inner Mission'),
        'neighbourhood/85866841': new GenericLazyString(() => 'Civic Center'),
        'neighbourhood/85865899': new GenericLazyString(
            () => 'Financial District',
        ),
        'neighbourhood/85887435': new GenericLazyString(() => 'Lower Nob Hill'),
        'neighbourhood/85866851': new GenericLazyString(() => 'Union Square'),
        'neighbourhood/85837317': new GenericLazyString(() => 'North Beach'),
        'neighbourhood/85866847': new GenericLazyString(() => 'Lower Haight'),
        'neighbourhood/85865905': new GenericLazyString(() => 'Downtown'),
        'neighbourhood/85865941': new GenericLazyString(() => 'Mission Bay'),
        'neighbourhood/85882195': new GenericLazyString(() => 'Rincon Hill'),
        'neighbourhood/85865947': new GenericLazyString(
            () => 'Duboce Triangle',
        ),
        'neighbourhood/85865951': new GenericLazyString(
            () => 'Mission Dolores',
        ),
        'neighbourhood/1108831803': new GenericLazyString(
            () => 'Showplace Square',
        ),
        'neighbourhood/85865991': new GenericLazyString(() => 'Presidio'),
        'neighbourhood/85865945': new GenericLazyString(() => 'Bernal Heights'),
    },
};

export const parentLocations: ParentLocation[] = [
    LOS_ANGELES_SUBLOCALITY_FILTER,
    CHICAGO_SUBLOCALITY_FILTER,
    NEW_YORK_SUBLOCALITY_FILTER,
    SAN_FRANCISCO_SUBLOCALITY_FILTER,
];

export const getParentLocationForSlug = (locationSlug?: string) =>
    locationSlug
        ? parentLocations.find(
              ({ parentSlug }) => locationSlug.indexOf(parentSlug) === 0,
          )
        : undefined;
